<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">挂号信息</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="no">挂号单号：{{detail.recordId}}</div>
				<div class="msg">
					<div class="item">
						<div class="label">顾客姓名：</div>
						<div class="value">{{detail.memberName}}</div>
					</div>
					<div class="item">
						<div class="label">手机号码：</div>
						<div class="value">{{detail.memberMobile}}</div>
					</div>
					<div class="item">
						<div class="label">挂号时间：</div>
						<div class="value">{{$public.FTime(detail.createTime,'YYYY-MM-DD HH:mm')}}</div>
					</div>
					<div class="item">
						<div class="label">主治医生：</div>
						<div class="value">{{detail.doctorName}}</div>
					</div>
					<div class="item">
						<div class="label">宠物昵称：</div>
						<div class="value">{{detail.petName}}</div>
					</div>
					<div class="item">
						<div class="label">宠物品种：</div>
						<div class="value">{{detail.typeName}}</div>
					</div>
					<div class="item">
						<div class="label">宠物性别：</div>
						<div class="value">{{detail.sex}}</div>
					</div>
					<div class="item">
						<div class="label">宠物年龄：</div>
						<div class="value">
							{{$public.FTime(new Date(detail.birthDay).getTime(),'YYYY-MM-DD')}}
							<span style="color:#1853A4;margin-left:10px;">
								({{$public.FAge(new Date(detail.birthDay).getTime())[0]}}岁
								{{$public.FAge(new Date(detail.birthDay).getTime())[1]}}月)
							</span>
						</div>
					</div>
					<div class="item">
						<div class="label">状态：</div>
						<div class="value">
							<div style="color:#FD4E4E">{{detail.status==1?'待接诊':''}}</div>
							<div style="color:#18A44C">{{detail.status==2?'已接诊':''}}</div>
							<div style="color:#949494">{{detail.status==3?'已完成':''}}</div>
						</div>
					</div>
					<div class="item">
						<div class="label">备注：</div>
						<div class="value">
							{{detail.remark}}
						</div>
					</div>
				</div>
				<div class="relation">
					<el-button style="margin-top:10px;" type="text" @click="zhuyuanTableState=!zhuyuanTableState">
						关联病例<i class="el-icon--right" :class="zhuyuanTableState?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
					</el-button>
					<el-table v-show="zhuyuanTableState" :data="tableData" style="width:100%" height="300px">
						<el-table-column label="编号" width="80">
							<template slot-scope="props">
								{{parseInt(props.$index+1)}}
							</template>
						</el-table-column>
						<el-table-column label="病例单号">
							<template slot-scope="props">
								<!-- <span class="biaoqianA" @click="toBingliSee(props.row.caseNumber)">{{props.row.caseNumber}}</span> -->
								<span >{{props.row.caseNumber}}</span>
							</template>
						</el-table-column>
						<el-table-column label="病例时间" width="200">
							<template slot-scope="props">
								<div>{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}</div>
							</template>
						</el-table-column>
						<el-table-column label="添加时间" width="200">
							<template slot-scope="props">
								<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm')}}</div>
							</template>
						</el-table-column>
						<el-table-column label="是否检测" width="150">
							<template slot-scope="props">
								<div style="color:#FD4E4E" v-if="props.row.isInspect==0">未检测</div>
								<div style="color:#18A44C" v-if="props.row.isInspect==1">已检测</div>
							</template>
						</el-table-column>
						<el-table-column label="状态" width="150">
							<template slot-scope="props">
								<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
								<div style="color:#FD4E4E" v-else>未支付</div>
							</template>
						</el-table-column>
						<el-table-column label="备注" width="200" prop="remark">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				detail: [],
				zhuyuanTableState:true,
				tableData:[],
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			jiezhenParams(){
				return this.$store.state.yiliaoxin.jiezhenParams;
			},
		},
		mounted(){
			this.getDetail();
			this.getList();
		},
		methods: {
			// 返回
			back(){
				this.$store.commit("yiliaoxin/remove_router")
				if(this.$store.state.yiliaoxin.router.length===0){
					this.jiezhenParams.type = 'list'
					this.$store.commit("yiliaoxin/set_jiezhenParams",this.jiezhenParams)
					this.$store.commit('yiliaoxin/set_curBusiness','接诊')
				}
				
				// if(
				// 	this.$store.state.yiliaoxin.curBusinessPre==='工作台'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rBingli'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rYmqc'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rZhuyuan'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenDai'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenZhong'
				// ){
				// 	this.$store.commit('yiliaoxin/set_curBusiness',this.$store.state.yiliaoxin.curBusinessPre)
				// 	return 
				// }
				// this.jiezhenParams.type = 'list'
				// this.$store.commit("yiliaoxin/set_jiezhenParams",this.jiezhenParams)
			},
			getDetail(){
				let params = {
					"recordId": this.jiezhenParams.curRow.recordId,
				}
				this.$http.get('/api/Registration/Detail', params).then(res => {
					if (res.code == 0) {
						this.detail = res.data;
					}
				})
			},
			toBingliSee(caseNumber){
				if(this.userInfo.staffId===this.detail.doctorId){
					this.$router.push({path:'/yiliao/bingliEdit',query:{eid:caseNumber}})
				}else{
					this.$router.push({path:'/yiliao/bingliSee',query:{sid:caseNumber}})
				}
				
			},
			getList(){
				let params = {
					"departmentId":'', // -1:不限；1：内科；2：外科
					"petId": '', 
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					"desc": false, // true  倒序  false 正序
					registrationRecordId:this.jiezhenParams.curRow.recordId,
					"begin_time": "",
					"end_time": "",
					"pageIndex": 1,
					"pageSize": 50,
					"keyword": ''
				}
				this.$http.post('/api/Case/List', params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.data||[];
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;padding:23px 0 20px;width:100%;height: calc(100% - 47px);box-sizing: border-box;
				.no{
					font-size: 14px;color:$fontColor;font-weight: bold;padding:0 24px 24px;
				}
				.msg{
					display: flex;flex-wrap: wrap;padding:0 24px 8px;border-bottom:1px solid #f2f2f2;
					.item{
						width:20%;font-size: 12px;color:$fontColor;display: flex;padding-bottom:16px;
						.label{
							width:60px;text-align: right;
						}
						.value{
							text-align: left;
						}
					}
				}
				.relation{
					padding:0 24px 8px;
				}
			}
		}
	}
</style>
